import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';
import { Icon } from '@plone/volto/components';
import { defineMessages, useIntl } from 'react-intl';
import { flattenToAppURL } from '@plone/volto/helpers';

import bankSVG from '@redturtle/volto-io-studio/icons/bankSVG.svg';
import bookmarkCheck from '@redturtle/volto-io-studio/icons/bookmarkCheck.svg';
import cardChecklist from '@redturtle/volto-io-studio/icons/cardChecklist.svg';
import pinMaker from '@redturtle/volto-io-studio/icons/pinMaker.svg';
import mortarboard from '@redturtle/volto-io-studio/icons/mortarboard.svg';
import vCard from '@redturtle/volto-io-studio/icons/vCard.svg';
import translate from '@redturtle/volto-io-studio/icons/translate.svg';
import text from '@redturtle/volto-io-studio/icons/text.svg';

import './corsiBlock.less';

const messages = defineMessages({
  course_type: {
    id: 'course_type',
    defaultMessage: 'Tipo di corso',
  },
  // course_location: {
  //   id: 'course_location',
  //   defaultMessage: 'Sede didattica',
  // },
  course_language: {
    id: 'course_language',
    defaultMessage: 'Lingua',
  },
  course_type_access: {
    id: 'course_type_access',
    defaultMessage: 'Tipo di accesso',
  },
  course_program_class: {
    id: 'course_program_class',
    defaultMessage: 'Tipo di corso',
  },
  course_president: {
    id: 'course_president',
    defaultMessage: 'Presidente',
  },
  department: {
    id: 'department',
    defaultMessage: 'Dipartimento',
  },
  course_teachings: {
    id: 'course_teachings',
    defaultMessage: 'Insegnamenti',
  },
  course_teachings_text: {
    id: 'course_teachings_text',
    defaultMessage: 'Consulta il piano di studi',
  },
  seeMore: {
    id: 'seeMore',
    defaultMessage: 'Approfondisci',
  },
});

const View = ({ content }) => {
  const intl = useIntl();

  return (
    <div className="block full-width corsiBlock">
      {content ? (
        <div className="ui container">
          {content.course_type?.title && (
            <div className="item">
              <div className="icon">
                <Icon className="bankSVG" name={bankSVG} />
              </div>
              <div className="content">
                <p className="title">
                  {intl.formatMessage(messages.course_type)}
                </p>
                <p className="text">{content.course_type?.title}</p>
              </div>
            </div>
          )}

          {/* {content.course_location?.title && (
            <div className="item">
              <div className="icon">
                <Icon className="pinMaker" name={pinMaker} />
              </div>
              <div className="content">
                <p className="title">
                  {intl.formatMessage(messages.course_location)}
                </p>
                <p className="text">{content.course_location?.title}</p>
              </div>
            </div>
          )} */}

          {content.course_language?.length > 0 && (
            <div className="item">
              <div className="icon">
                <Icon className="translate" name={translate} />
              </div>
              <div className="content">
                <div className="title">
                  {intl.formatMessage(messages.course_language)}
                </div>
                <div className="text">
                  <p>
                    {content.course_language
                      ?.map((item) => item.title)
                      .join(', ')}
                  </p>
                </div>
              </div>
            </div>
          )}

          {
            //da verificare cosa arriverà, course_type_of_access è null al momento
          }
          {content.course_type_of_access?.length > 0 && (
            <div className="item">
              <div className="icon">
                <Icon className="cardChecklist" name={cardChecklist} />
              </div>
              <div className="content">
                <p className="title">
                  {intl.formatMessage(messages.course_type_access)}
                </p>
                <p className="text">{content.course_type_of_access}</p>
              </div>
            </div>
          )}

          {
            //da verificare cosa arriverà, course_programme_class è null al momento
          }
          {content.course_programme_class?.length > 0 && (
            <div className="item">
              <div className="icon">
                <Icon className="bookmarkCheck" name={bookmarkCheck} />
              </div>
              <div className="content">
                <p className="title">
                  {intl.formatMessage(messages.course_program_class)}
                </p>
                <p className="text">{content.course_programme_class}</p>
              </div>
            </div>
          )}
          {/*
            Al momento il presidente è semplicemente un testo, valutare se in futuro deve diventare un link o una pagina
          */}
          {content.president && (
            <div className="item">
              <div className="icon">
                <Icon className="vCard" name={vCard} />
              </div>
              <div className="content">
                <p className="title">
                  {intl.formatMessage(messages.course_president)}
                </p>
                <p className="text">{content.president}</p>
              </div>
            </div>
          )}

          {content.department?.length > 0 && (
            <div className="item">
              <div className="icon">
                <Icon className="mortarboard" name={mortarboard} />
              </div>
              <div className="content">
                <p className="title">
                  {intl.formatMessage(messages.department)}
                </p>
                {content.department?.map((item) => (
                  <UniversalLink href={item.href}>{item.title}</UniversalLink>
                ))}
              </div>
            </div>
          )}

          {content.teachings?.length > 0 && (
            <div className="item">
              <div className="icon">
                <Icon className="text-icon" name={text} />
              </div>
              <div className="content">
                <p className="title">
                  {intl.formatMessage(messages.course_teachings)}
                </p>
                {content.teachings && (
                  <UniversalLink item={content.teachings[0]}>
                    {intl.formatMessage(messages.course_teachings_text)}
                  </UniversalLink>
                )}
              </div>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */

View.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default View;
